import React from 'react';

import './app-page-main.scss';

const AppPageMain: React.FC = ({ children }) => (
  <main className="main">{children}</main>
);

export default AppPageMain;
